import interactionParserUtils from './InteractionParserUtils';
import constants from '../../../Constants';

const customGeogebraParser = {
    parse(interaction, language, defaultLanguage, responseDeclarations) {
        const extraResponseDeclarations = responseDeclarations.filter(eR => eR.identifier === 'pngBase64');
        let height = parseInt(interaction.getAttribute('inspera:height'), 10);
        if (isNaN(height)) {
            height = 600;
        }
        if (extraResponseDeclarations.length === 0) {
            const mockExtraResponseDeclaration = {
                baseType: 'string',
                cardinality: 'single',
                identifier: constants.extraResponseIdentifiers.CUSTOM_INTERACTION.pngBase64,
            };
            extraResponseDeclarations.push(mockExtraResponseDeclaration);
        }
        return {
            extraResponseDeclarations,
            geogebraBase64: interaction.getAttribute('inspera:geogebraBase64'),
            height,
            prompt: interactionParserUtils.getPrompt(interaction, language, defaultLanguage),
            type: constants.interactionType.CUSTOM_INTERACTION_GEOGEBRA,
        };
    },
};

export default customGeogebraParser;
